import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout, { PolicySection } from "./PolicyLayout";

function Delivery() {
  return (
    <PolicyLayout
      title="Shipping & Delivery Policy"
      intro="This policy explains how mefurvexo prepares and delivers online orders. The options, price, and estimate shown at checkout for your destination take priority for that order."
      contactSubject="shipping or delivery"
    >
      <PolicySection title="1. Destinations, methods, and charges">
        <p>
          Available destinations and delivery methods are determined by the address
          entered at checkout. Shipping charges are shown before payment. If a
          destination or method is not displayed, it is not currently available
          through the online checkout.
        </p>
      </PolicySection>

      <PolicySection title="2. Processing and dispatch">
        <p>
          Orders are prepared after payment confirmation and any necessary fraud or
          address review. Processing time is separate from carrier transit time.
          Orders placed on weekends, public holidays, or during high-volume periods
          may begin processing on the next working day. A dispatch message and
          tracking reference are sent when available.
        </p>
      </PolicySection>

      <PolicySection title="3. Delivery estimates">
        <p>
          A delivery estimate is not a guaranteed arrival date unless expressly
          identified as guaranteed. Weather, customs, carrier disruption, remote
          locations, and events outside reasonable control can affect transit. If a
          material delay occurs, contact us and we will review the available carrier
          information and remedies required by law.
        </p>
      </PolicySection>

      <PolicySection title="4. Address accuracy and changes">
        <p>
          Check the name, address, unit number, postcode, and contact details before
          paying. Send an address-change request immediately under our{" "}
          <Link to="/cancellations">Order Changes &amp; Cancellation Policy</Link>. A
          change cannot be guaranteed after processing or dispatch. Additional
          carrier costs caused by an incorrect or incomplete address may be charged
          only where permitted and disclosed before re-delivery.
        </p>
      </PolicySection>

      <PolicySection title="5. International orders and customs">
        <p>
          Cross-border orders may be inspected or delayed by customs. Unless the
          checkout expressly says duties and import taxes are included, the
          recipient is responsible for amounts lawfully charged by the destination
          country. We provide truthful customs information and will not mark a
          commercial order as a gift or declare an artificially low value.
        </p>
      </PolicySection>

      <PolicySection title="6. Delivery, safe place, and collection">
        <p>
          A carrier may require a signature or offer collection or safe-place
          options under its own terms. Choose an option suitable for the address.
          Where law allows, risk passes when the order is delivered to you or a
          person you identified to receive it, not merely when it leaves us.
        </p>
      </PolicySection>

      <PolicySection title="7. Failed or refused delivery">
        <p>
          If an order is returned because delivery was refused, not collected, or
          the address was inaccurate, contact us. After the parcel is received and
          inspected, we may offer re-delivery at the actual additional cost or treat
          it as a return. Original or return shipping deductions apply only where
          disclosed, reasonable, and permitted by law.
        </p>
      </PolicySection>

      <PolicySection title="8. Missing, damaged, or incorrect parcels">
        <p>
          Inspect the parcel promptly and keep its packaging. Send the order number,
          a description, and clear photographs where relevant. We may need a signed
          confirmation or carrier investigation, but this does not remove a remedy
          you have for goods that were not delivered, arrived damaged, or were
          incorrectly supplied. See the <Link to="/warranty">Warranty &amp; Faulty Goods Policy</Link>.
        </p>
      </PolicySection>

      <PolicySection title="9. Split shipments and packaging">
        <p>
          An order may arrive in more than one parcel where operationally necessary.
          Any additional charge will be disclosed or absorbed by us. We aim to use
          packaging appropriate to protect the products without making an unverified
          environmental claim.
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}

export default Delivery;
